/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserListItemVm
 */
export interface UserListItemVm {
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListItemVm
     */
    orgName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListItemVm
     */
    isRegistered?: boolean;
}

export function UserListItemVmFromJSON(json: any): UserListItemVm {
    return UserListItemVmFromJSONTyped(json, false);
}

export function UserListItemVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListItemVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'orgName': !exists(json, 'orgName') ? undefined : json['orgName'],
        'isRegistered': !exists(json, 'isRegistered') ? undefined : json['isRegistered'],
    };
}

export function UserListItemVmToJSON(value?: UserListItemVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'username': value.username,
        'orgName': value.orgName,
        'isRegistered': value.isRegistered,
    };
}


